import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root',
})
export class LangService {
	defFontSrc = ['../assets/fonts/neutra_text_medium.otf', '../assets/fonts/neutra_text_bold.otf', '../assets/fonts/neutr_text_light.otf'];
	specFontSrc = [
		'../assets/fonts/JosefinSans-Regular.ttf',
		'../assets/fonts/JosefinSans-Bold.ttf',
		'../assets/fonts/JosefinSans-Light.ttf',
	];

	constructor(private translate: TranslateService) {}

	init() {
		const languageValue = localStorage.getItem('langOfApp');
		if (languageValue) {
			// Migrate legacy Czech code (`cr`) to the correct `cs` to avoid missing translations.
			const normalizedLanguage = languageValue === 'cr' ? 'cs' : languageValue;
			if (normalizedLanguage !== languageValue) {
				localStorage.setItem('langOfApp', normalizedLanguage);
			}

			this.changeLanguage(normalizedLanguage);
		} else {
			this.changeLanguage('de');
		}

		this.translate.onLangChange.subscribe(languageChanged => {
			this.translate.setDefaultLang(languageChanged.lang);
			if (languageChanged) localStorage.setItem('langOfApp', languageChanged.lang);
		});
	}

	changeLanguage(language: string) {
		this.translate.use(language);
		this.loadFonts(language);
	}

	async loadFonts(lang: string) {
		const fonts = lang === 'cs' ? this.specFontSrc : this.defFontSrc;
		const fontFamilies = ['AppFont', 'AppFontBold', 'AppFontLight'];

		await Promise.all(
			fonts.map(async (fontSrc, i) => {
				const font = new FontFace(fontFamilies[i], `url(${fontSrc})`);
				font.stretch = 'condensed';
				await font.load();
				(document.fonts as any).add(font);
			})
		);
	}
}
